export default __webpack_public_path__ + "static/img_cloud_apps-dab7f311ca7a732d6b80158340861488.png";